module.exports = __webpack_public_path__ + "static/media/slider-l1-360.c2e0e0c3.webp";